import { render, staticRenderFns } from "./PdfContent.vue?vue&type=template&id=bd10b834&scoped=true&"
import script from "./PdfContent.vue?vue&type=script&lang=js&"
export * from "./PdfContent.vue?vue&type=script&lang=js&"
import style0 from "./PdfContent.vue?vue&type=style&index=0&id=bd10b834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd10b834",
  null
  
)

export default component.exports